import { DatePipe } from '@angular/common';
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cue5050Site } from '../../_models/fundraising/Cue5050Site';
import { FaqItem } from '../../_models/fundraising/FundraisingSite';
import { Cue5050SiteService } from '../../_services/fundraising/cue5050Site.service';
import { AuthService } from '../../_services/auth.service';
import { DialogService } from '../../_services/dialog.service';
import { PhotoService } from '../../_services/photo.service';
import { S3Service } from '../../_services/s3.service';
import { forkJoin, Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators'
import { DomSanitizer } from '@angular/platform-browser';
import bwipjs from 'bwip-angular2';
import { QRCode, QRCodePricingTier } from '../../_models/fundraising/QRCode';
import { QRCodeService } from '../../_services/fundraising/qrCode.service';
import { Environment } from '../../../environments/environment';

@Component({
  selector: 'app-vendor-website-create',
  templateUrl: './vendor-website-create.component.html',
  styleUrls: ['./vendor-website-create.component.css']
})
export class VendorWebsiteCreateComponent implements OnInit, AfterContentChecked {

  public form: FormGroup;

  public hasValidationErrors: boolean;

  public cue5050Site: Cue5050Site;
  public siteId: number;

  public availableHostname: boolean;

  public generatingQR = false;

  public environment: string;

  private legalPdf: File =  null;

  // public codes: QRCode[] = [];
  // public codeTierLinks: QRCodePricingTier[] =[];

  constructor(
    private fb: FormBuilder,
    private cue5050SiteService: Cue5050SiteService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private cdRef: ChangeDetectorRef,
    private datePipe: DatePipe,
    private imageService: PhotoService,
    private s3Service: S3Service,
    private sanitizer: DomSanitizer,
    private qrService: QRCodeService
  ) { }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges()
  }

  ngOnInit(): void {

    this.spinner.show();

    this.environment = Environment.name.includes('dev') || Environment.name.includes('local') ? '.dev.' : '.';

    //const siteObs = this.fundraisingService.getSiteData();
    //const qrObs = this.qrService.getCodes();
    //const pricingObs = this.qrService.getAllPricingTierLinks();

    this.cue5050SiteService.getSiteData()
        .subscribe(data => {
          this.spinner.hide();
          this.cue5050Site = data;
          // this.cue5050Site.currentEvents = this.cue5050Site.currentEvents.filter(e => e.event.enableOnlineSales);
          // this.codes = data[1];
          // this.codeTierLinks = data[2];
          if (this.cue5050Site === null){
            this.siteId = 0;
          } else {
            this.siteId = this.cue5050Site.cue5050SiteId;
            this.availableHostname = true;
          }
          this.createForm(this.cue5050Site);
        },
          error => {
            this.spinner.hide();
            this.dialogService.alert('Unable to load cue5050 site data.', error.error, this.viewRef);
          })

  }

  formControls(name: string) {
    return this.form.controls[name];
  }

  createForm(vendorWebsite: Cue5050Site) {
    this.form = this.fb.group({
      name: [vendorWebsite?.name || '', [Validators.required, Validators.pattern("^(([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])$")]],
      primaryColor: [vendorWebsite?.primaryColor || "#FFFFFF", [Validators.required, Validators.pattern('#([A-Fa-f0-9]{6})')]],
      secondaryColor: [vendorWebsite?.secondaryColor || "#FFFFFF", [Validators.required, Validators.pattern('#([A-Fa-f0-9]{6})')]],
      legalUrl: [vendorWebsite?.legalUrl || '', Validators.required],
      bannerUrl: [vendorWebsite?.bannerUrl || '', Validators.required],
      logoUrl: [vendorWebsite?.logoUrl || '', Validators.required],
      sponsorUrl: [vendorWebsite?.sponsorUrl || ''],
      advertisementText: [vendorWebsite?.advertisementText || ''],
      advertisementUrl: [vendorWebsite?.advertisementUrl || ''],
      faq: this.createFaqFormGroup(vendorWebsite?.faq),
      baseQRUrl: [vendorWebsite?.baseQRUrl || ''],
      //qrCodes: this.createQRFormGroup(this.codes, this.codeTierLinks)
    });
  }

  savePdf(file: File) {
    if (file && file.type === 'application/pdf') {
      this.legalPdf = file;
      const tempUrl = URL.createObjectURL(file);
      const safeUrl = this.sanitizer.bypassSecurityTrustUrl(tempUrl);
      this.form.controls.legalUrl.patchValue(safeUrl);
    } else {
      this.form.controls.logoUrl.setErrors({ notPdf: true });
      this.form.controls.logoUrl.markAsTouched();
    }
  }

  uploadPdf(file: File): Observable<string> {
    if (file && file.type === 'application/pdf') {
      const lastDotIdx = file.name.lastIndexOf('.');
      const name = file.name.substring(0, lastDotIdx);
      const extension = file.name.substring(lastDotIdx + 1);
      const uniqueName = `${name}_${Date.now()}.${extension}`;
      return this.s3Service.uploadFile(file, `fundraising/${localStorage.getItem('vendorName')}/5050/legal/` + uniqueName, "get-signed-s3-url", 'application/pdf')
        .pipe(map(uploadUrl => {
          return Environment.s3CdnUrl + this.s3Service.getUrlWithoutSignature(uploadUrl.split('s3.amazonaws.com')[1])
        }))
    } else {
        this.form.controls.logoUrl.setErrors({ notPdf: true });
        this.form.controls.logoUrl.markAsTouched();
    }
  }

  deletePdf(){
    if (this.formControls('legalUrl').value !== ''){
      this.dialogService
      .confirm(
        'This will remove and delete your PDF.',
        'Are you sure you want to do this?',
        this.viewRef)
        .then(result => {
          if (result) {
            if (this.siteId > 0){
              const lastSlashIdx = this.formControls('legalUrl').value.lastIndexOf('/');
              const name = this.formControls('legalUrl').value.substring(lastSlashIdx + 1);
              this.cue5050SiteService.deleteLegalPdf(name)
                .subscribe(() => {
                  this.form.patchValue({ legalUrl: ''});
                  const siteData = new Cue5050Site(this.form.getRawValue());
                  this.cue5050SiteService.update(siteData)
                    .subscribe(res => {
                      this.dialogService.alert(
                        "File Deleted.",
                        "Your legal PDF has been deleted.",
                        this.viewRef);
                    },
                    error => {
                      this.spinner.hide();
                      this.dialogService.alert('Oops something went wrong..', error.error, this.viewRef);
                    });
                },
                error => {
                  this.spinner.hide();
                  this.dialogService.alert('Oops something went wrong..', error.error, this.viewRef);
                });
              } else {
                this.form.patchValue({ legalUrl: ''});
              }
            }
        });
    }
  }

  uploadImage(file: File, type: string, correctDimensions: boolean) {

    switch(type){
      case 'logo':
        if (file && file.type === 'image/png' && correctDimensions) {
          this.imageService.enqueueUploadPhoto(file, 'logo-image', { height: 44, width: 60 }, false, true).subscribe(res => {
            this.form.patchValue({ logoUrl: res.url });
          });
        } else {
          this.form.controls.logoUrl.setErrors({ incorrectDimensions: true});
          this.form.controls.logoUrl.markAsTouched();
        }
        break;

      case 'banner':
        if (file && file.type.includes('image') && correctDimensions) {
          this.imageService.enqueueUploadPhoto(file, 'banner-image', { height: 768, width: 1366 }, false, true).subscribe(res => {
            this.form.patchValue({ bannerUrl: res.url });
          });
        } else {
          this.form.controls.bannerUrl.setErrors({ incorrectDimensions: true });
          this.form.controls.bannerUrl.markAsTouched();
        }
        break;

      case 'sponsor':
        if (file && file.type.includes('image') && correctDimensions) {
          this.imageService.enqueueUploadPhoto(file, 'sponsor-image', { height: 406, width: 1380 }, false, true).subscribe(res => {
            this.form.patchValue({ sponsorUrl: res.url });
          });
        } else {
          this.form.controls.sponsorUrl.setErrors({ incorrectDimensions: true});
          this.form.controls.sponsorUrl.markAsTouched();
        }

      default:
        break;
    }

    this.form.markAsDirty();
  }

  verifyImageDimensions (file: File, type: string) {

    const verifyAspectRatio = type === 'banner' ? true : false;
    let correctWidth = type === 'banner' ? 1366 : type === 'logo' ? 60 : type === 'sponsor' ? 1380 : 0;
    let correctHeight = type === 'banner' ? 768 : type === 'logo' ? 44 : type === 'sponsor' ? 406 : 0;

    let dimensionObs = of(false);

    if (verifyAspectRatio) {

      dimensionObs = this.imageService.meetsImageConstraints(file, correctWidth, correctHeight, 1.77, 0.01);

    } else {

      dimensionObs = this.imageService.meetsImageConstraints(file, correctWidth, correctHeight);
    }

    dimensionObs
      .subscribe(
        correct => {

          this.uploadImage(file, type, correct);
        }
      );
  }

  checkHostnameAvailability(){
    this.cue5050SiteService.getHostnameAvailability(this.formControls('name').value)
      .subscribe(res => {
        this.availableHostname = res;
      });
  }

  createFaqFormGroup(faqItems: FaqItem[]){

    const f = new FormArray<FormGroup>([]);

    if (faqItems && faqItems.length > 0) {
      faqItems.forEach(q =>
        f.push(this.fb.group({
          head: [q.head, Validators.required],
          paragraph: [q.paragraph, Validators.required],
        }))
      );
    } else {
      f.push(this.fb.group({
        head: ['', Validators.required],
        paragraph: ['', Validators.required],
      }));
      for (let i = 0; i < 4; i++){
        f.push(this.fb.group({
          head: [''],
          paragraph: [''],
        }));
      }
    }

    return f;
  }
  validateFaq() {
   return !!this.form.controls.faq['controls'].every(control =>control.controls.head.value && control.controls.paragraph.value)
  }

  newFaqItem() {
    (<FormArray>this.form.controls.faq)
      .push(
        this.fb.group({
          head: [null, Validators.required],
          paragraph: [null, Validators.required],
        })
      );
    this.form.controls.faq.markAsDirty();
    this.form.updateValueAndValidity();
  }

  deleteFaqItem(tierIndex: number) {
    (<FormArray>this.form.controls.faq).removeAt(tierIndex);
    this.form.controls.faq.markAsDirty();
    this.form.updateValueAndValidity();
  }

  getCodeLinks(code: QRCode, links: QRCodePricingTier[]): QRCodePricingTier{
    const relevantLink = links.filter(link => link.qrCodeId === code.qrCodeId);
    if (!relevantLink || relevantLink.length !== 1){
      return null;
    }
    return relevantLink[0];
  }

  getCue5050(id: any){
    const event = this.cue5050Site.currentEvents.filter(cue5050 => cue5050.pricingTiers.some(t => t.cue5050PricingTierId === id));
    if (event?.length !== 1){
      return null;
    } else {
      return event[0]?.cue5050Id;
    }
  }

  getPricingTiers(id: number){
    const event = this.cue5050Site.currentEvents.filter(e => e.cue5050Id === +id);
    return event[0].pricingTiers;
  }

  createQRFormGroup(codes: QRCode[], codeTierLinks) {

    const f = new FormArray<FormGroup>([]);

    if (codes && codes.length > 0) {
      codes.forEach(qr =>
        f.push(this.fb.group({
          qrCodeId: [qr.qrCodeId || 0, Validators.required],
          referenceNumber: [qr.referenceNumber || '', Validators.required],
          vendorId: [qr.vendorId || 0, Validators.required],
          imageLink: [qr.imageLink || '', Validators.required],
          qrCodePricingTier: this.fb.group({
            qrCodePricingTierId: [this.getCodeLinks(qr,codeTierLinks)?.qrCodePricingTierId ?? 0],
            qrCodeId: [qr.qrCodeId],
            cue5050PricingTierId: [this.getCodeLinks(qr, codeTierLinks)?.cue5050PricingTierId ?? 0],
            cue5050Id: [this.getCue5050(this.getCodeLinks(qr, codeTierLinks)?.cue5050PricingTierId) ?? 0]
          })
        }))
      );
    }
    return f;
  }

  newQRCodeFormGroup(data: QRCode){
    console.log(data);
    (<FormArray>this.form.controls.qrCodes)
      .push(
        this.fb.group({
          qrCodeId: [data.qrCodeId || 0, Validators.required],
          referenceNumber: [data.referenceNumber || '', Validators.required],
          vendorId: [data.vendorId || 0, Validators.required],
          imageLink: [data.imageLink || '', Validators.required],
          qrCodePricingTier: this.fb.group({
            qrCodePricingTierId: [0],
            qrCodeId: [data.qrCodeId],
            cue5050PricingTierId: [0],
            cue5050Id: [0]
          })
        })
      );
    this.form.controls.qrCodes.markAsDirty();
    this.form.updateValueAndValidity();

    return (<FormArray>this.form.controls.qrCodes).length - 1;
  }

  newQRCode(){
    this.spinner.show();
    this.qrService.addNewCode()
      .subscribe(code => {
        const idx = this.newQRCodeFormGroup(code);
        this.generateQRCodeFile(code.referenceNumber, `api.cueaudio.com/fundraising/qr/public/${code.referenceNumber}`)
          .subscribe(file => {
            this.spinner.hide();
            this.imageService.enqueueUploadPhoto(file, file.name, { height: 200, width: 200 }, false, true)
              .subscribe(res => {
                this.form.get(`qrCodes.${idx}`).patchValue({imageLink: res.url});
              })
          })
      }, error => {
        this.spinner.hide();
        this.dialogService.alert('Oops something went wrong...', error.error, this.viewRef);
      })
  }

  generateBaseQRCode () {

    this.spinner.show('qrSpinner');
    this.generatingQR = true;

    this.generateQRCodeFile('Base', `https://${this.form.get('name').value + this.environment}cue5050.com`)
      .subscribe(file => {

        this.spinner.hide('qrSpinner');

        this.imageService.enqueueUploadPhoto(file, file.name, { height: 2400, width: 2400 }, false, true)
              .subscribe(res => {

                this.generatingQR = false;
                this.form.markAsDirty();
                this.form.patchValue({baseQRUrl: res.url});
              })
      })
  }


  generateQRCodeFile(name: string, link: string): Observable<File>{
    const canvas = document.createElement('canvas');

    return new Observable<File>(subscriber => {
      bwipjs(canvas, {
        bcid: 'qrcode',
        text: link,
        scale: 3,               // 3x scaling factor
        height: 635,
        width: 635,              // Bar height, in millimeters
        includetext: true,            // Show human-readable text only if not code 128
        textxalign: 'center',        // Always good to set this
      }, async (err, cvs) => {
        if (err) {
          console.log(err);
        } else {
          canvas.toBlob((blob) => {
            const file = new File([blob], `QR-${name}.png`, {type:'image/png'});
            subscriber.next(file);
            subscriber.complete();
          },'image/png', 1)
        }
      });
    })
  }

  validateUrl () {

    const regex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gm);

    const controlValue = this.form.controls.advertisementUrl.value;

    if (!regex.test(controlValue) && controlValue.length > 0) {

      this.form.controls.advertisementUrl.setErrors({invalid: true})
      this.form.controls.advertisementUrl.markAsTouched();
    }
  }

  onEventSelect(idx: number){
    const qrGroup = this.form.get(`qrCodes.${idx}.qrCodePricingTier`) as FormGroup;

    qrGroup.controls.cue5050PricingTierId.setValidators(null);

    if (qrGroup.controls.cue5050Id.value > 0){
      qrGroup.controls.cue5050PricingTierId.setValidators(Validators.min(1));
    }else {
      qrGroup.controls.cue5050PricingTierId.patchValue(0);
    }

    qrGroup.controls.cue5050PricingTierId.updateValueAndValidity();
  }

  public onNavigatingAway() {
    if (!this.form || !this.form.dirty) {
      return true;
    } else {
      return this.dialogService.confirm('Unsaved Changes', 'Are you sure you want to continue? Any unsaved changes will be lost!', this.viewRef);
    }
  }

  async save(){
    this.hasValidationErrors = !this.form.valid;
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    if (this.hasValidationErrors) {
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }
    this.spinner.show();

    const imageObs = this.imageService.commitUploads();
    const pdfObs = this.legalPdf ? this.uploadPdf(this.legalPdf) : of(null);

    forkJoin([imageObs, pdfObs])
    .pipe(mergeMap((data) => {

      if (data[1]) {

        this.form.patchValue({ legalUrl: data[1] });
      }

      const siteData = new Cue5050Site(this.form.getRawValue());
      siteData.name = siteData.name.toLowerCase();
      // const qrData = (<FormArray>this.form.get('qrCodes')).getRawValue();
      // const qrLinksData: QRCodePricingTier[] = qrData.map(element => {
      //   return element.qrCodePricingTier;
      // });

      // const linkObs = this.qrService.updatePricingTierLinks(qrLinksData);
      // const qrObs = this.qrService.updateVendorCodes(qrData);
      if(this.siteId > 0) {
        return this.cue5050SiteService.update(siteData);
      } else {
        return this.cue5050SiteService.create(siteData);
      }
    }))
    .subscribe(newSite => {
      this.spinner.hide();
      this.form.markAsPristine();
      this.dialogService
      .confirm(
        'Website Saved!',
        'Would you like to continue editing?',
        this.viewRef)
        .then(result => {
          if (!result) {
            this.navigateUp();
          }
        });
    },
      err => {
        this.spinner.hide();
        this.dialogService.alert('Oops something went wrong..', 'We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues', this.viewRef);
        console.log(err);
      });
  }

  public navigateUp() {
    this.router.navigate(['../'], {relativeTo: this.route});
  }

}
